import React from "react"

import Header from '../components/Header';
import Footer from '../components/Footer';
import Logo from '../components/Logo'
import SEO from '../components/seo';

import SplashBg from '../images/splash-3.jpg'

const IndexPage = () => (
  <>
  <div
    style={{
      height: '100vh',
      backgroundImage: `url(${SplashBg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      position: 'relative',
    }}
  >
    <SEO title="Home"  />
    <Header />
    <div style={{
      position: 'absolute',
      left: '0',
      right: '0',
      top: '25%',
    }}>
      <div style={{
          maxWidth: `450px`,
          margin: '0 auto',
          padding: '0 50px'
      }}>
        <Logo />
      </div>
    </div>

  </div>
  <Footer />
  </>
)

export default IndexPage
